<template>
  <div>
    <el-image
      :src="$domain + 'static/noten/website/newHome/top_banner1.png'"
      alt="编程"
      style="width: 100%;height: 600px;"
    ></el-image>

    <div class="center content">
      <div style="width: 1200px;" class="between">
        <div class="left">
          <Messages
            v-for="(i, index) in hourList"
            :key="index"
            :Data="i"
          ></Messages>
        </div>
        <div class="right">
          <div class="labels">
            <div class="title">相关标签</div>
            <div class="bar"></div>
            <div class="label">
              <div
                class="item center-just"
                v-for="(i, index) in labelList"
                :key="index"
              >
                {{ i.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Messages from "@/views/message/components/messages";
import api from "@/api";
import { messageList } from "@/api/port";
export default {
  components: { Messages },
  data() {
    return {
      tid: "",
      hourList: [],
      labelList: []
    };
  },
  created() {
    this.getDataList();
    this.getLabelList();
  },
  methods: {
    getDataList() {
      api
        .post(messageList.getMessageList, {})
        .then(res => {
          console.log("数据", res);
          this.hourList = res.list;
        })
        .catch(error => {
          // 捕获异常并处理
          console.error("Error:", error);
        });
    },
    getLabelList() {
      api
        .post(messageList.getLabelList, {})
        .then(res => {
          console.log("数据", res);
          this.labelList = res.list;
        })
        .catch(error => {
          // 捕获异常并处理
          console.error("Error:", error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100vm;
  background: #f9f9f9;
  // min-height: 100vh;
  padding-top: 67px;
  .left {
    width: 723px;
  }
  .right {
    width: 450px;
    height: 388px;
    background: #ffffff;
    border-radius: 10px;
    .labels {
      margin: 0px 20px 0px 20px;
      .title {
        margin: 30px 0px 30px 0px;
      }
      .bar {
        width: 410px;
        height: 1px;
        background: #f2f2f2;
      }
      .label {
        width: 356px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 30px;
        .item {
          width: 80px;
          height: 30px;
          background: #e8f9ff;
          border-radius: 15px;
          margin-bottom: 12px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #06bbff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/message/index.vue